var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import '@/assets/css/app.css';
import '@/assets/css/ReactToastify.css';
import { ColorModeContext, useMode } from '@/hooks/theme';
import '@/utils/i18n';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import 'react-lazy-load-image-component/src/effects/opacity.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { useDispatch, useSelector } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import Loader from './components/layout/common/Loader';
import Routes from './routes';
import { userInfoSelectUserInfo } from './store/auth/selectors';
import { THEME_VALUE } from './utils/constants';
import { DEFAULT_FONT_FAMILY, DEFAULT_LANGUAGE, getDefaultTheme, } from './utils/helpers';
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import { settingsService, writeAuditLogin, } from './services/setting/application/settings';
import { handleCheckLogin, handleCheckLoginType } from './store/login/reducer';
import { API_STATUS_CODE } from './utils/api/types';
import { checkAuthRequest } from './store/auth/actions';
var myCache = createCache({
    key: 'mobility-console',
    nonce: 'RANDOM_NONCE',
    speedy: false,
});
var App = function () {
    var userInfo = useSelector(userInfoSelectUserInfo);
    var is_login = useSelector(function (state) { return state.isLogin; }).is_login;
    var dispatch = useDispatch();
    var getThemeMode = function (userInfoProp) {
        var _a, _b;
        return (_b = (_a = userInfoProp === null || userInfoProp === void 0 ? void 0 : userInfoProp.setting) === null || _a === void 0 ? void 0 : _a.theme) !== null && _b !== void 0 ? _b : getDefaultTheme();
    };
    var getUserFontFamily = function (userInfoProp) {
        var _a, _b;
        return (_b = (_a = userInfoProp === null || userInfoProp === void 0 ? void 0 : userInfoProp.setting) === null || _a === void 0 ? void 0 : _a.font) !== null && _b !== void 0 ? _b : DEFAULT_FONT_FAMILY;
    };
    var getUserLang = function (userInfoProp) {
        var _a, _b;
        return (_b = (_a = userInfoProp === null || userInfoProp === void 0 ? void 0 : userInfoProp.setting) === null || _a === void 0 ? void 0 : _a.language) !== null && _b !== void 0 ? _b : DEFAULT_LANGUAGE;
    };
    var isAuthenticated = useSelector(function (state) { return state.auth; }).isAuthenticated;
    var _a = useMode(getThemeMode(userInfo), getUserFontFamily(userInfo)), theme = _a[0], colorMode = _a[1];
    var loadingMain = useSelector(function (state) { return state.layout; }).loadingMain;
    var i18n = useTranslation().i18n;
    var handleAuditLogLogin = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, writeAuditLogin()];
                case 1:
                    _a.sent();
                    dispatch(handleCheckLogin({ is_login: true }));
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        if (!['/reset-pasword'].includes(location.pathname)) {
            dispatch(checkAuthRequest());
        }
    }, [dispatch]);
    useEffect(function () {
        var checkDomainSetting = function () { return __awaiter(void 0, void 0, void 0, function () {
            var _a, data, errorCode;
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, settingsService.getDomainSetting(location.hostname)];
                    case 1:
                        _a = _c.sent(), data = _a.data, errorCode = _a.errorCode;
                        if (errorCode !== API_STATUS_CODE.SUCCESS)
                            return [2 /*return*/];
                        dispatch(handleCheckLoginType({ login_type: Number((_b = data === null || data === void 0 ? void 0 : data[0]) === null || _b === void 0 ? void 0 : _b.domain_type) }));
                        return [2 /*return*/];
                }
            });
        }); };
        if (location.pathname === '/login' || location.pathname === '/settings') {
            checkDomainSetting();
        }
    }, [dispatch, userInfo]);
    useEffect(function () {
        if (!is_login) {
            handleAuditLogLogin();
        }
    }, [userInfo]);
    useEffect(function () {
        i18n.changeLanguage(getUserLang(userInfo));
        colorMode.changeFontFamily(getUserFontFamily(userInfo));
        var userTheme = getThemeMode(userInfo);
        if (userTheme === THEME_VALUE.DEFAULT) {
            userTheme = getDefaultTheme();
        }
        colorMode.changeColorMode(userTheme);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userInfo]);
    return (_jsx(CacheProvider, { value: myCache, children: _jsxs(ColorModeContext.Provider, { value: colorMode, children: [(loadingMain || isAuthenticated === null) && _jsx(Loader, {}), _jsxs(ThemeProvider, { theme: theme, children: [_jsx(ToastContainer, { limit: 1, position: "top-right", autoClose: 5000, hideProgressBar: true, closeOnClick: true, draggable: true, style: { maxWidth: 400, left: 'unset', color: '#fff' }, theme: theme.palette.mode }), _jsx(CssBaseline, {}), _jsx(Routes, {})] })] }) }));
};
export default App;
